import { sendGTMEvent } from '@/modules/common/services/sendGTMEvent';
import { DATA_LAYER_EVENTS } from '@/modules/product/services/data-layer-events/events';

type OpenDataLayerEventProps = {
  feature: string;
  where?: string;
};

export function openDataLayerEvent({ feature, where }: OpenDataLayerEventProps) {
  sendGTMEvent({ ecommerce: null, eventData: null });
  sendGTMEvent({
    event: DATA_LAYER_EVENTS.open,
    eventData: { feature, where },
  });
}
